import { lazy } from "react";

export const ActsRules = lazy(() => import("../../Features/ActsRules"));

export const GrievanceRedressal = lazy(
  () => import("../../Features/GrievanceRedressal")
);

export const HundredDaysProgram = lazy(
  () => import("../../Features/HundredDaysProgram")
);

export const RtsList = lazy(() => import("../../Features/RtsList"));

export const ImportantGR = lazy(
  () => import("../../Features/ImportantGovernmentResolution")
);

export const Notifications = lazy(() => import("../../Features/Notifications"));

export const UserManual = lazy(() => import("../../Features/UserManual"));

export const RightToInformation = lazy(
  () => import("../../Features/RightToInformation")
);

export const ApplicationForm = lazy(
  () => import("../../Features/ApplicationForm")
);

export const MinutesOfMeeting = lazy(
  () => import("../../Features/MinutesOfMeeting")
);

export const BudgetaryProvision = lazy(
  () => import("../../Features/BudgetaryProvision")
);
